import { Controller } from "@hotwired/stimulus"

// Toggles the app sidebar on mobile (slide-in overlay). On desktop the sidebar is always visible.
export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  connect() {
    this.media = window.matchMedia("(min-width: 768px)")
    this.media.addEventListener("change", this.closeIfDesktop.bind(this))
  }

  disconnect() {
    this.media?.removeEventListener("change", this.closeIfDesktop.bind(this))
  }

  toggle() {
    if (this.media?.matches) return
    const open = this.sidebarTarget.getAttribute("data-sidebar-open") === "true"
    this.setOpen(!open)
  }

  close() {
    this.setOpen(false)
  }

  closeIfDesktop() {
    if (this.media?.matches) this.setOpen(false)
  }

  setOpen(open) {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.setAttribute("data-sidebar-open", open)
    this.sidebarTarget.classList.toggle("-translate-x-full", !open)
    this.sidebarTarget.classList.toggle("translate-x-0", open)
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle("hidden", !open)
    }
  }
}
